const GTM_ID = 'GTM-PBTSCBRB';
const GTM_HEAD_SCRIPT_ID = 'gtm-head-script';
const GTM_NOSCRIPT_ID = 'gtm-noscript';

export const loadGoogleTagManager = (gtmId = GTM_ID) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {};
  }

  if (!document.getElementById(GTM_HEAD_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = GTM_HEAD_SCRIPT_ID;
    script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;

    const firstHeadChild = document.head.firstChild;
    if (firstHeadChild) {
      document.head.insertBefore(script, firstHeadChild);
    } else {
      document.head.appendChild(script);
    }
  }

  if (!document.getElementById(GTM_NOSCRIPT_ID)) {
    const noscript = document.createElement('noscript');
    noscript.id = GTM_NOSCRIPT_ID;
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    const firstBodyChild = document.body.firstChild;
    if (firstBodyChild) {
      document.body.insertBefore(noscript, firstBodyChild);
    } else {
      document.body.appendChild(noscript);
    }
  }

  return () => {
    document.getElementById(GTM_HEAD_SCRIPT_ID)?.remove();
    document.getElementById(GTM_NOSCRIPT_ID)?.remove();
  };
};
